.header {
  display: flex;
  gap: 0.5rem;
}

.info {
  display: flex;
  flex-direction: column;
}

.timestamp {
  display: flex;
  font-size: 13px;
  font-weight: var(--font-weight-light);
  color: var(--on-body);
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.intro {
  font-size: 13px;
}

.title {
  font-size: 14px;
}

.cover {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
}

.source {
  & > * {
    margin: 0;
    font-size: inherit;
    line-height: inherit;
    color: var(--on-body);
  }
}

.description {
  margin: 0.5rem 0;
}

.icon {
  width: 21px;
  vertical-align: top;
  fill: transparent;

  &.favorited {
    fill: currentColor;
  }
}

.actions {
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
  justify-content: flex-end;
}

.item {
  padding: 0.25rem 0.5rem !important;
}

.root::after {
  content: "";
  transition: box-shadow 1s;
}

.highlight {
  position: relative;

  &::after {
    position: absolute;
    top: -1.25rem;
    right: -1rem;
    bottom: 0;
    left: -1rem;
    pointer-events: none;
    box-shadow: 0 0 3px 2px var(--primary) inset;
  }
}
